module.exports = __webpack_public_path__ + "img/47.62974474.jpg";